<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
const flat = require("flat");
import * as set from "lodash/set";
import * as get from "lodash/get";
import getFormComponentTree from "./functions/getFormComponentTree";
import arrayifyControls from "./functions/arrayifyControls";

export default {
  props: [
    "onDone",
    "onSubmit",
    "onSuccess",
    "onFail",
    "requiredFields",
    "hiddenFields",
    "disabledFields",
    "initOnMount"
  ],
  data() {
    return {
      controls: {},
      errors: {}
    };
  },
  methods: {
    /* Strips the models fields to those that are present in the form */
    getFormValue(model) {
      const map = flat(model);
      this.controls = this.getControls();
      const strippedModel = {};
      for (const key in map) {
        if (map.hasOwnProperty(key)) {
          if (get(this.controls, key)) {
            if (get(model, key) !== '') {
                set(strippedModel, key, get(model, key));
            }
          }
        }
      }
      return strippedModel;
    },
    submit(model) {
      const formValue = this.getFormValue(model);

      return this.onSubmit(formValue)
        .then(data => {
          this.clearErrors();

          if (this.onSuccess) this.onSuccess(data);
        })
        .catch(e => {
          if (e && e.status == 422) {
            this.clearErrors();
            this.setErrors(e.data.errors);
          } else {
            console.error("catch", e);
          }

          if (this.onFail) this.onFail();
        })
        .finally(e => {
          if (this.onDone) this.onDone();
        });
    },
    getControls() {
      return getFormComponentTree(this);
    },
    clearErrors() {
      const controlsAsArray = arrayifyControls(this.controls);

      for (let i = 0; i < controlsAsArray.length; i++) {
        controlsAsArray[i].clearError();
      }

      this.errors = {};
    },
    setErrors(errorDict = {}) {
      for (const key in errorDict) {
        if (errorDict.hasOwnProperty(key)) {
          const control = get(this.controls, key);

          if (control && control.setError) {
            control.setError(errorDict[key]);
          }
        }
      }

      setTimeout(() => {
        let field = null;

        if (field = $('.is-invalid')[0]) {
          field.scrollIntoView(false);
        }
      }, 500)

      this.errors = errorDict;
    },
    init() {
      this.controls = this.getControls();

      if (this.requiredFields) {
        this.requiredFields.forEach(key => {
          const control = get(this.controls, key);

          if (control && control.$parent) {
            control.setRequired(true);
            control.$forceUpdate();
          }
        });
      }

      if (this.hiddenFields) {
        this.hiddenFields.forEach(key => {
          const control = get(this.controls, key);

          if (control && control.$parent) {
            control.setHidden(true);
            control.$forceUpdate();
          }
        });
      }

      if (this.disabledFields) {
        this.disabledFields.forEach(key => {
          const control = get(this.controls, key);
          if (control && control.$parent) {
            control.setDisabled(true);
            control.$forceUpdate();
          }
        });
      }
    }
  },
  mounted() {
    if (this.initOnMount !== false) this.init();
  }
};
</script>
